import { CSSProperties, Suspense } from "react";
import { Link } from "react-router-dom";
import { useBjelinTranslations } from "../hooks/TranslationHooks";
import { useProductUrl } from "../utils/ProductUtils";
import { useProductWithCockpitId } from "../hooks/ProductHooks";
import { useCurrentUser } from "../functional-components/UserContext";
import Icon from "./Icon";

const ProductLinkInner = ({
  id,
  style,
  showPrefix
}: {
  id: string;
  style: CSSProperties;
  showPrefix: boolean;
}) => {
  const { admin } = useCurrentUser();
  const t = useBjelinTranslations();
  const product = useProductWithCockpitId(id);
  const url = useProductUrl(product);
  if (!url || !product?.name) {
    console.warn(
      "ProductLink to unavailable product",
      product?.sku || product?.art_id || id
    );
    return admin ? (
      <h4 className={"text-bold text-danger"}>Unavailable ProductLink: {id}</h4>
    ) : null;
  }
  return (
    <span style={{ whiteSpace: "nowrap" }}>
      {showPrefix && t("product.in.picture") + ": "}
      <Link to={url} style={style}>
        {product.name}
      </Link>
    </span>
  );
};

const ProductLink = ({
  id,
  style = {},
  showPrefix = false
}: {
  id: string;
  style?: CSSProperties;
  showPrefix?: boolean;
}) => {
  return (
    <Suspense fallback={<Icon name="spinner" className="fa-pulse" />}>
      <ProductLinkInner id={id} style={style} showPrefix={showPrefix} />
    </Suspense>
  );
};

export default ProductLink;
